import {useRouteQuery} from '@vueuse/router';
import {isEqual} from 'lodash-es';

export default function useVariadicRouteQuery(name: string) {
	const query = useRouteQuery(name);

	return computed({
		get(): string[] | null {
			return query.value === null || query.value === undefined
				? null
				: typeof query.value === 'string'
					? query.value.split(',')
					: query.value.join().split(',');
		},
		set(value: string[] | null) {
			if (!isEqual(value, query.value)) {
				query.value = value?.join() || null;
			}
		},
	});
}
